export default {
  // Navigation
  'nav.home': 'Startseite',
  'nav.about': 'Über uns',
  'nav.features': 'Funktionen',
  'nav.partners': 'Partner',
  'nav.testimonials': 'Erfahrungsberichte',
  'nav.login': 'Anmelden',
  'nav.portal': 'Mitgliederportal',
  
  // Hero
  'hero.title': 'Lernen. Verdienen. Einkaufen. Einlösen.',
  'hero.subtitle': 'Verwandeln Sie Ihre Lernreise in Belohnungen mit HoneyMoneyUnits (HMU)',
  'hero.cta.primary': 'HMU Verdienen Starten',
  'hero.cta.secondary': 'Mehr Erfahren',
  
  // Stats
  'stats.activeUsers': 'Aktive Benutzer',
  'stats.hmuEarned': 'HMU Verdient',
  'stats.partners': 'Partnermarken',
  'stats.rewards': 'Belohnungen Eingelöst',
  
  // Features
  'features.title': 'Wie HoneyJar Funktioniert',
  'features.learn.title': 'Lernen',
  'features.learn.desc': 'Schließen Sie Bildungsmodule ab und verdienen Sie HMU',
  'features.earn.title': 'Verdienen',
  'features.earn.desc': 'Interagieren Sie mit Partnermarken und sammeln Sie Punkte',
  'features.shop.title': 'Einkaufen',
  'features.shop.desc': 'Durchsuchen Sie exklusive Waren und Partnerangebote',
  'features.redeem.title': 'Einlösen',
  'features.redeem.desc': 'Tauschen Sie Ihre HMU gegen Belohnungen und Produkte ein',
  'features.levelup.title': 'Aufsteigen',
  'features.levelup.desc': 'Schalten Sie Abzeichen, Serien und exklusive Vorteile frei',
  
  // Portal
  'portal.welcome': 'Willkommen zurück',
  'portal.hmuBalance': 'HMU-Guthaben',
  'portal.tierProgress': 'Stufenfortschritt',
  'portal.currentStreak': 'Aktuelle Serie',
  'portal.badges': 'Gesammelte Abzeichen',
  'portal.activeMissions': 'Aktive Missionen',
  'portal.partnerOffers': 'Partnerangebote',
  'portal.recommendations': 'Personalisierte Empfehlungen',
  
  // Missions
  'missions.title': 'Missionen',
  'missions.all': 'Alle',
  'missions.learning': 'Lernen',
  'missions.affiliate': 'Partner',
  'missions.completed': 'Abgeschlossen',
  'missions.active': 'Aktive Missionen',
  'missions.completedCount': 'Abgeschlossen',
  'missions.earned': 'HMUs Verdient',
  'missions.timeInvested': 'Investierte Zeit',
  'missions.start': 'Mission Starten',
  'missions.continue': 'Fortsetzen',
  'missions.completed.btn': 'Abgeschlossen',
  'missions.referralBonus': 'Empfehlungsbonus',
  'missions.streakBonus': 'Serienbonus',
  
  // Rewards
  'rewards.title': 'Belohnungskatalog',
  'rewards.all': 'Alle',
  'rewards.bewear': 'B.E. Wear',
  'rewards.digital': 'Digitale Produkte',
  'rewards.partner': 'Partnerangebote',
  'rewards.redeem': 'Einlösen',
  'rewards.locked': 'Gesperrt',
  'rewards.earnCPV': 'Verdienen',
  'rewards.earnCCV': 'pro Konversion',
  'rewards.selectSize': 'Größe Auswählen',
  
  // Auth
  'auth.login': 'Anmelden',
  'auth.register': 'Registrieren',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.name': 'Vollständiger Name',
  'auth.location': 'Standort',
  'auth.referralCode': 'Empfehlungscode (Optional)',
  'auth.welcomeBonus': 'Erhalten Sie 50 HMU Willkommensbonus!',
  'auth.optIn.tracking': 'Ich stimme der Aktivitätsverfolgung zu',
  'auth.optIn.notifications': 'Ich möchte Benachrichtigungen erhalten',
  'auth.optIn.partnerOffers': 'Ich möchte Partnerangebote erhalten',
  'auth.noAccount': 'Haben Sie kein Konto?',
  'auth.hasAccount': 'Haben Sie bereits ein Konto?',
  'auth.signUp': 'Registrieren',
  'auth.signIn': 'Anmelden',
  
  // Footer
  'footer.tagline': 'Lernen durch Belohnungen stärken',
  'footer.company': 'Unternehmen',
  'footer.about': 'Über Uns',
  'footer.careers': 'Karriere',
  'footer.press': 'Presse',
  'footer.contact': 'Kontakt',
  'footer.resources': 'Ressourcen',
  'footer.blog': 'Blog',
  'footer.help': 'Hilfezentrum',
  'footer.faq': 'FAQ',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.compliance': 'Compliance',
  'footer.rights': 'Alle Rechte vorbehalten',
  'footer.owner': 'Bingham ENT Global Empire',
  
  // Common
  'common.currency': 'HMU',
  'common.days': 'Tage',
  'common.hours': 'Stunden',
  'common.minutes': 'Minuten',
  'common.loading': 'Laden...',
  'common.error': 'Ein Fehler ist aufgetreten',
  'common.success': 'Erfolg!',
};